import getAssetUrl from 'utils/getAssetUrl';

export const grillsBackground = getAssetUrl('/uploads/activity_image/image/155/a.jpg');

export const programQuoteImage = getAssetUrl('/assets/carousel/FOTO_1.jpg');
